<template>
  <div id="mc_embed_shell" class="p-0">
    <div id="mc_embed_signup">
      <form
        id="mc-embedded-subscribe-form"
        class="validate"
        action="https://sqwerv.us21.list-manage.com/subscribe/post?u=2335dafa399ada5e0975315c9&id=9965df6e21&f_id=0058e4e6f0"
        method="post"
        name="mc-embedded-subscribe-form"
        target="_blank"
      >
        <div id="mc_embed_signup_scroll" class="flex flex-col space-y-2">
          <div class="mc-field-group">
            <label for="mce-EMAIL" class="label-text text-neutral-content mb-1"
              >Email Address</label
            >
            <div class="relative">
              <input
                id="mce-EMAIL"
                class="input input-bordered w-full pr-16"
                type="email"
                name="EMAIL"
                required
                value=""
                placeholder="user@site.com"
              />
              <input
                id="mc-embedded-subscribe"
                class="btn btn-primary absolute top-0 right-0 rounded-l-none"
                type="submit"
                name="subscribe"
                value="Subscribe"
              />
            </div>
          </div>
          <div id="mce-responses" class="clear foot">
            <div
              id="mce-error-response"
              class="response text-error"
              style="display: none"
            ></div>
            <div
              id="mce-success-response"
              class="response text-success"
              style="display: none"
            ></div>
          </div>
          <div aria-hidden="true" style="position: absolute; left: -5000px">
            /* real people should not fill this in and expect good things - do
            not remove this or risk form bot signups */
            <input
              type="text"
              name="b_2335dafa399ada5e0975315c9_9965df6e21"
              tabindex="-1"
              value=""
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup></script>

<style scoped></style>
